import type { JSONContent } from '@tiptap/vue-3'

import { generateHTMLFromJSON } from './generateHTMLFromJSON'

export const getImagesIdsFromEditorContent = (content: Nullable<JSONContent>) => {
  if (!content) {
    return []
  }
  const imagesIds: string[] = []

  generateHTMLFromJSON(content)
    .querySelectorAll('img[data-id]')
    .forEach((img) => {
      imagesIds.push(img.getAttribute('data-id')!)
    })

  return imagesIds
}
